import { ApiResponse } from '@core/models/api-response.model';
import { MemberLog } from '@core/models/member-log.model';
import { tap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';

@Injectable()
export class MemberLogDataService extends DefaultDataService<MemberLog>  {

  pagination: Pagination;

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('MemberGroup', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<MemberLog[]> {
    return this.http.get<ApiResponse>('/member/actionlog').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<MemberLog[]>{
    return this.http.get<ApiResponse>(`/member/actionlog${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
